import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { apiMiddleware } from 'redux-api-middleware';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers/index';
import apiAuthInjector from './helpers/api_auth_injector'

const predicate = process.env.NODE_ENV === 'development';

const logger = createLogger({
  level: 'info',
  collapsed: false,
  logger: console,
  predicate: () => predicate,
});

export default function configureStore() {
  const w = typeof window === 'object' && typeof window.devToolsExtension !== 'undefined';

  const store = createStore(
    rootReducer,
    compose(applyMiddleware(
      thunkMiddleware,
      apiAuthInjector,
      apiMiddleware,
      logger,
    ), w ? window.devToolsExtension() : f => f),
  );

  if (module.hot && predicate) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers/index', () => {
      const nextRootReducer = rootReducer;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/store.js